import * as actionTypes from "../constants/action-types";

//reducer is a function that receives an action and returns new state.
let initialState = { data: [], loading: true, error: "" };

export const comprasReducer = (state = initialState, action) => {
  switch (action.type)
  {
    case actionTypes.FETCH_COMPRAS:
      return { data: [], loading: true, error: ""};

    case actionTypes.FETCH_COMPRAS_SUCCESS:
      return { data: action.payload, loading: false, error: ""};
  
    case actionTypes.FETCH_COMPRAS_ERROR:
      return { data: state, loading: false, error: action.payload};
  
    default:
      return state;
  }
};

export const UltcomprasReducer = (state = initialState, action) => {
  switch (action.type)
  {
    case actionTypes.FETCH_ULT_COMPRAS_ING:
      return { data: [], loading: true, error: ""};

    case actionTypes.FETCH_ULT_COMPRAS_ING_SUCCESS:
      return { data: action.payload, loading: false, error: ""};
  
    case actionTypes.FETCH_ULT_COMPRAS_ING_ERROR:
      return { data: state, loading: false, error: action.payload};
  
    default:
      return state;
  }
};

export const proveedoresReducer = (state = initialState, action) => {
  switch (action.type)
  {
    case actionTypes.FETCH_PROVEEDORES:
      return { data: [], loading: true, error: ""};

    case actionTypes.FETCH_PROVEEDORES_SUCCESS:
      return { data: action.payload, loading: false, error: ""};
  
    case actionTypes.FETCH_PROVEEDORES_ERROR:
      return { data: state, loading: false, error: action.payload};
  
    default:
      return state;
  }
};
